import { setInputTestId } from "@bcc/components/ui/input/input.utils";
import { generateTestId } from "@client-shared";

export const setPreferencesViewTestId = (identifier: string): string => generateTestId("PreferencesView", identifier);

export const setPreferencesViewContainerTestId = (): string => setPreferencesViewTestId("container");

export const setPreferencesViewTitleTestId = (): string => setPreferencesViewTestId("title");

export const setPreferencesViewDescriptionTestId = (): string => setPreferencesViewTestId("description");

// Sub-component helpers used by preferences/* components.
// These will migrate to mailing-preferences.utils.ts in a future plan.

export const setPreferencesViewRoasterInfoCardTestId = (): string => setPreferencesViewTestId("roaster-info-card");

export const setPreferencesViewRoasterInfoTitleTestId = (): string => setPreferencesViewTestId("roaster-info-title");

export const setPreferencesViewRoasterInfoDescriptionTestId = (): string => setPreferencesViewTestId("roaster-info-description");

export const setPreferencesViewBillingAddressCardTestId = (): string => setPreferencesViewTestId("billing-address-card");

export const setPreferencesViewBillingAddressTitleTestId = (): string => setPreferencesViewTestId("billing-address-title");

export const setPreferencesViewBillingAddressDescriptionTestId = (): string => setPreferencesViewTestId("billing-address-description");

export const setPreferencesViewShippingAddressCardTestId = (): string => setPreferencesViewTestId("shipping-address-card");

export const setPreferencesViewShippingAddressTitleTestId = (): string => setPreferencesViewTestId("shipping-address-title");

export const setPreferencesViewShippingAddressDescriptionTestId = (): string => setPreferencesViewTestId("shipping-address-description");

export const setPreferencesViewProfileInfoCardTestId = (): string => setPreferencesViewTestId("profile-info-card");

export const setPreferencesViewProfileInfoTitleTestId = (): string => setPreferencesViewTestId("profile-info-title");

export const setPreferencesViewProfileInfoDescriptionTestId = (): string => setPreferencesViewTestId("profile-info-description");

export const setPreferencesViewSaveChangesButtonTestId = (): string => setPreferencesViewTestId("save-changes-button");

export const setPreferencesViewChooseFileButtonTestId = (): string => setPreferencesViewTestId("choose-file-button");

export const setPreferencesViewSaveLogoButtonTestId = (): string => setPreferencesViewTestId("save-logo-button");

export const setPreferencesViewMailingTabTriggerTestId = (): string => setPreferencesViewTestId("mailing-tab-trigger");

export const setPreferencesViewPrintingTabTriggerTestId = (): string => setPreferencesViewTestId("printing-tab-trigger");

export const setPreferencesViewConnectionsTabTriggerTestId = (): string => setPreferencesViewTestId("connections-tab-trigger");

// Shipping address input field test IDs (generated from RHF field names)
export const setPreferencesViewShippingStreetInputTestId = (): string => setInputTestId("shippingAddress.address1");

export const setPreferencesViewShippingCityInputTestId = (): string => setInputTestId("shippingAddress.city");

export const setPreferencesViewShippingZipInputTestId = (): string => setInputTestId("shippingAddress.zip");
